module.exports = __webpack_public_path__ + "a0cd30921deefb2f484783afa43436af.svg";